module.exports = __webpack_public_path__ + "img/img_logoFooter.b7e65dc2.webp";